export default __webpack_public_path__ + "static/media/graphite-01.6f3526cd.png";